/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycPersonFormDto } from '../../models/kyc-person-form-dto';

export interface UpdateIndividualForm$Params {
  processId: string;
      body: KycPersonFormDto
}

export function updateIndividualForm(http: HttpClient, rootUrl: string, params: UpdateIndividualForm$Params, context?: HttpContext): Observable<StrictHttpResponse<KycPersonFormDto>> {
  const rb = new RequestBuilder(rootUrl, updateIndividualForm.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycPersonFormDto>;
    })
  );
}

updateIndividualForm.PATH = '/kyc/processes/{processId}/individual-form';
